import { A as n, a, b as o, c as t, C as l, G as r, M as p } from "./conversations-B6_5aJ5K.js";
const e = {
  eligible: "eligible",
  ineligible: "ineligible",
  unknown: "unknown"
};
export {
  n as AccountType,
  a as AnalysisReportEvents,
  o as AssessmentLights,
  t as ConversationMemberType,
  l as ConversationPhase,
  r as GroupType,
  p as MessageType,
  e as VicSmartEligibility
};
//# sourceMappingURL=types.js.map
